const normalizeEnv = (value: string | undefined) => value?.trim() || undefined;
const normalizeAppEnv = (value: string | undefined) => {
  const normalized = normalizeEnv(value)?.toLowerCase();
  if (normalized === "prod" || normalized === "production") return "prod";
  if (normalized === "test" || normalized === "testing") return "test";
  return "dev";
};

export const ENV = normalizeEnv(import.meta.env.VITE_ENV) as string;
export const APP_ENV = normalizeAppEnv(
  import.meta.env.VITE_APP_ENV ?? import.meta.env.VITE_ENV,
);
export const APP_NAME = "recon-frontend";
export const APP_SOURCE = "frontend";
export const APP_VERSION =
  normalizeEnv(import.meta.env.VITE_APP_VERSION) || "local";
export const GIT_SHA = normalizeEnv(import.meta.env.VITE_GIT_SHA) || "unknown";
export const COGNITO_CLIENT_ID = normalizeEnv(
  import.meta.env.VITE_COGNITO_CLIENT_ID,
);
export const COGNITO_REGION =
  normalizeEnv(import.meta.env.VITE_COGNITO_REGION) || "us-east-1";
export const COGNITO_USER_POOL_ID = normalizeEnv(
  import.meta.env.VITE_COGNITO_USER_POOL_ID,
);
export const siteSessionTokenKeyName = "token";
export const siteSessionRefresh = "refresh";
export const siteSessionIdTokenKeyName = "id_token";
export const siteSessionAccessTokenKeyName = "access_token";
export const siteSessionExpiresAt = "session_expires_at";
export const isDevEnvironment = ENV !== "prod";
export const POSTHOG_KEY = normalizeEnv(
  import.meta.env.VITE_PUBLIC_POSTHOG_KEY,
);
export const POSTHOG_HOST =
  normalizeEnv(import.meta.env.VITE_PUBLIC_POSTHOG_HOST) ||
  "https://us.i.posthog.com";
